import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => {}); }, [slug]);

  if (!post) return <div className="ca-container py-16 text-slate-500">Loading…</div>;

  return (
    <div className="ca-container py-12 max-w-3xl">
      <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-teal mb-6"><ArrowLeft className="h-4 w-4" /> Back to Blog</Link>
      <span className="text-xs font-semibold text-teal">{post.category}</span>
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-2">{post.title}</h1>
      <p className="text-sm text-slate-400 mt-2">{post.author} · {post.date}</p>
      <div className="mt-6 prose prose-slate max-w-none">
        {post.content.split("\n").map((line, i) => {
          if (line.startsWith("### ")) return <h3 key={i} className="font-display font-semibold text-lg text-slate-900 mt-5">{line.slice(4)}</h3>;
          if (line.startsWith("## ")) return <h2 key={i} className="font-display font-bold text-2xl text-slate-900 mt-6">{line.slice(3)}</h2>;
          if (line.trim() === "") return null;
          return <p key={i} className="text-slate-700 leading-relaxed mt-3">{line}</p>;
        })}
      </div>
      <div className="mt-8 rounded-xl bg-slate-50 border border-slate-200 p-4 text-xs text-slate-500">
        Source: ComplaintAdvisor Editorial · Jurisdiction: {post.jurisdiction} · Last reviewed: {post.reviewed}. General information only, not legal advice.
      </div>
    </div>
  );
}
